import http from "../httpService";
import moment from 'moment'

const apiEndpoint = "/report/admin";

export function getReportAdminSummary({filter='today', date=moment().format('YYYY-MM-DD')}) {
    return http.get(apiEndpoint + '/domain/summary/?filter=' + filter + '&date=' + date)
  }